// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lZtJ","left":"styles_left__3r52W","right":"styles_right__1yJwg","alert":"styles_alert__2NfRm"};